import { radials } from '@/styles/shared';
export const mainLayoutStyles = {
  headerContainer: {
    position: 'relative',
    zIndex: 1,
  },
  contentContainer: {
    margin: '0 auto',
    paddingTop: {
      xs: '20px',
      sm: '30px',
      md: '60px',
    },

    position: 'relative',
    zIndex: 1,
    width: '100%',
    maxWidth: '100%',
  },
  greenEllipseStyle: {
    position: 'absolute',
    bottom: '-200px',
    left: '50%',
    transform: 'translateX(-50%)',
    width: '792px',
    height: '792px',
    background: radials.greenSoft,
    borderRadius: '50%',
    filter: 'blur(8px)',
    zIndex: 0,
    // Prevent ellipse from interfering with mobile scrolling
    pointerEvents: 'none',
    // Hide on mobile to avoid scroll interference
    display: { xs: 'none', md: 'block' },
  },
  purpleEllipseStyle: {
    position: 'absolute',
    top: '10%',
    left: '30%',
    width: '832px',
    height: '832px',
    background: radials.purpleSoft,
    borderRadius: '50%',
    filter: 'blur(8px)',
    zIndex: 0,
    // Prevent ellipse from interfering with mobile scrolling
    pointerEvents: 'none',
    // Hide on mobile to avoid scroll interference
    display: { xs: 'none', md: 'block' },
  },
  portalLayoutContainerStyle: {
    minHeight: 'calc(var(--vh, 1vh) * 100)',
    backgroundColor: '#FFFFFF',
    position: 'relative',
    // Fix mobile scrolling: allow overflow for proper scrolling behavior
    overflow: { xs: 'visible', md: 'hidden' },
    padding: {
      xs: '5px 20px 20px 20px',
      sm: '30px',
      md: '20px 60px 20px 80px',
    },
  },
} as const;
